module.exports = __webpack_public_path__ + "static/img/solidwork2.4b6aee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/develop/solidwork/solidwork2.jpg
// module id = Bwnu
// module chunks = 0